import { render } from "./PhilosophieSection.vue?vue&type=template&id=b00603c0&scoped=true"
const script = {}

import "./PhilosophieSection.vue?vue&type=style&index=0&id=b00603c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00603c0"]])

export default __exports__